'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _feedItems = require('./feedItems');

var _feedItems2 = _interopRequireDefault(_feedItems);

var _reaction = require('./reaction');

var _reaction2 = _interopRequireDefault(_reaction);

var _tags = require('./tags');

var _tags2 = _interopRequireDefault(_tags);

var _follow = require('./follow');

var _follow2 = _interopRequireDefault(_follow);

var _userDetails = require('./user-details');

var _userDetails2 = _interopRequireDefault(_userDetails);

var _featuredAthletes = require('./featuredAthletes');

var _featuredAthletes2 = _interopRequireDefault(_featuredAthletes);

var _miniProfile = require('./miniProfile');

var _miniProfile2 = _interopRequireDefault(_miniProfile);

var _userTimeline = require('./userTimeline');

var _userTimeline2 = _interopRequireDefault(_userTimeline);

var _sharing = require('./sharing');

var _sharing2 = _interopRequireDefault(_sharing);

var _theatre = require('./theatre');

var _theatre2 = _interopRequireDefault(_theatre);

var _communityContent = require('./communityContent');

var _communityContent2 = _interopRequireDefault(_communityContent);

var _hudlVideoInterface = require('hudl-video-interface');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reducers = _extends({
  feedItems: _feedItems2.default,
  reaction: _reaction2.default,
  tags: _tags2.default,
  follow: _follow2.default,
  userDetails: _userDetails2.default,
  featuredAthletes: _featuredAthletes2.default,
  miniProfile: _miniProfile2.default,
  userTimeline: _userTimeline2.default,
  sharing: _sharing2.default,
  theatre: _theatre2.default,
  communityContent: _communityContent2.default
}, _hudlVideoInterface.viReducers);

exports.default = reducers;